import { ProductBuilderMachineStateSchemaStates } from '../../../types';
import { addToCart } from '../api/addToCart';
import { getCart } from '../api/getCart';
import { getProductWithMeasurements } from '../api/getProductWithMeasurements';
import { idleGuardedTransitions } from '../guards/idleTransitionGuards';

export const states: ProductBuilderMachineStateSchemaStates = {
  bladeSize: {},
  bottomRailColour: {},
  bracketColour: {},
  componentsColour: {},
  bottomBarColour: {},
  cellDesign: {},
  chainColour: {},
  chainPosition: {},
  chainRelease: {},
  chainType: {},
  colour: {},
  colourDay: {},
  colourNight: {},
  commonValance: {},
  complete: {
    initial: 'idle',
    states: {
      idle: {
        on: {
          ADD_TO_CART: {
            target: 'loading',
          },
        },
      },
      loading: {
        invoke: {
          src: addToCart,
          onDone: {
            target: 'success',
            actions: ['addToCartSuccess'],
          },
          onError: {
            target: 'failure',
            actions: ['addToCartFailure'],
          },
        },
      },
      success: {
        on: {
          ADD_TO_CART: {
            target: 'loading',
          },
        },
      },
      failure: {
        on: {
          ADD_TO_CART: {
            target: 'loading',
          },
        },
      },
    },
  },
  configuration: {},
  cordPosition: {},
  dayColour: {},
  dayFabricPosition: {},
  designerTape: {},
  driveControl: {},
  extensionPole: {},
  fitting: {},
  frameStyle: {},
  holdDownBrackets: {},
  idle: {
    initial: 'loading',
    states: {
      loading: {
        invoke: {
          src: getCart,
          onDone: {
            target: 'ready',
            actions: ['getCartSuccess'],
          },
          onError: {
            target: 'failure',
            actions: ['getCartFailure'],
          },
        },
      },
      ready: {
        always: idleGuardedTransitions,
      },
      failure: {
        always: idleGuardedTransitions,
      },
    },
  },
  liftPosition: {},
  lightGuards: {},
  lining: {},
  liningColour: {},
  liningStyle: {},
  materialType: {},
  materialTypeDay: {},
  materialTypeNight: {},
  measureInsurance: {
    initial: 'loading',
    states: {
      loading: {
        invoke: {
          src: getCart,
          onDone: {
            target: 'ready',
            actions: ['getCartSuccess'],
          },
          onError: {
            target: 'failure',
            actions: ['getCartFailure'],
          },
        },
      },
      ready: {},
      failure: {},
    },
  },
  measurements: {
    initial: 'idle',
    states: {
      idle: {
        always: [
          {
            target: 'ready',
            cond: 'hasProductWithMeasurements',
          },
        ],
      },
      loading: {
        invoke: {
          src: getProductWithMeasurements,
          onDone: {
            target: 'ready',
            actions: ['getProductWithMeasurementsSuccess'],
          },
          onError: {
            target: 'failure',
            actions: ['getProductWithMeasurementsFailure'],
          },
        },
      },
      ready: {},
      failure: {},
    },
  },
  mountingSurface: {},
  numberOfPanels: {},
  panelConfiguration: {},
  pleatType: {},
  pleatFinish: {},
  transparency: {},
  powerSupply: {},
  railColour: {},
  remoteControl: {},
  rollDirection: {},
  roomName: {},
  shipping: {},
  slatSize: {},
  stackSide: {},
  tiltControl: {},
  tiltPosition: {},
  track: {},
  trackRequire: {},
  trackColour: {},
  pullRod: {},
  pullRodColour: {},
  wifiHub: {},
  dynamicPrice: {},
  operation: {},
  smartRelease: {},
  fascia: {},
  venetianValance: {},
  totalPrice: {},
  smartReleasePrice: {},
  extensionPolePrice: {},
  lightGuardPrice: {},
  venetianValancePrice: {},
  trackPrice: {},
  fasciaPrice: {},
  measureInsurancePrice: {},
  stainlessSteelChain: {},
  stainlessSteelChainPrice: {},
  honeycombVerticalCentreOpeningSurcharge: {},
  honeycombVerticalCentreOpeningSurchargePrice: {},
  ceilingMountPleatedCurtainRail: {},
  faceMountPleatedCurtainRail: {},
  ceilingMountWaveFoldCurtainRail: {},
  faceMountWaveFoldCurtainRail: {},
  ceilingMountPleatedCurtainDoubleRail: {},
  faceMountPleatedCurtainDoubleRail: {},
  ceilingMountWaveFoldCurtainDoubleRail: {},
  faceMountWaveFoldCurtainDoubleRail: {},
  wand_option: {},
  wand_colour: {},
  wand_colour_price: {},
  wand_colour_variant_id: {},
  track_colour_variant_id: {},
  track_colour_price: {},
  lining_colour_variant_id: {},
  lining_colour_price: {},
} as const;
